import { render } from "./ForgotPassword.vue?vue&type=template&id=c308a558"
import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=c308a558&lang=css"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/passwordReset/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c308a558"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c308a558', __exports__)) {
    console.log('reload')
    api.reload('c308a558', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=c308a558", () => {
    console.log('re-render')
    api.rerender('c308a558', render)
  })

}


export default __exports__